import React from "react"
import ModalRoute from "./src/components/ModalRoute"

/**
 * Case-study overlays: keep the page a visitor came from mounted underneath
 * the one they opened, so posts linked with `state={{ modal: true }}` can
 * present as a sheet over it. See src/components/ModalRoute.js.
 *
 * Must stay identical to the `wrapPageElement` in gatsby-ssr.js or the first
 * client render won't match the server HTML.
 */
export const wrapPageElement = ({ element, props }) => (
  <ModalRoute element={element} location={props.location} />
)

/**
 * A modal transition isn't a page change: the window never moves (the sheet
 * scrolls itself, and the document is locked while it's open), so letting
 * Gatsby jump to the top would only lose the background page's position.
 * Closing pops history back to that page, which is already exactly where the
 * visitor left it.
 */
export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const isModal = (loc) => !!(loc && loc.state && loc.state.modal)
  if (isModal(routerProps && routerProps.location)) return false
  if (isModal(prevRouterProps && prevRouterProps.location)) return false
  return true
}
